<form
  class="form w-full"
  novalidate="novalidate"
  [formGroup]="registrationForm"
  (ngSubmit)="submit()"
>
  <!--begin::Heading-->
  <div class="text-center mb-11">
    <!--begin::Title-->
    <h4 class="text-dark font-bold mb-4">Sign Up</h4>
    <!--end::Title-->

    <!--begin::Subtitle-->
    <div class="text-gray-500 font-semibold">Your Social Campaigns</div>
    <!--end::Subtitle--->
  </div>
  <!--begin::Heading-->

  <!--begin::Login options-->
  <div class="flex items-center gap-3">
    <!--begin::Col-->
    <div class="w-1/2">
      <!--begin::Google link--->
      <button
        pButton
        [outlined]="true"
        severity="secondary"
        class="flex items-center !py-3 !px-4"
      >
        <img
          alt="Logo"
          src="./assets/media/svg/brand-logos/google-icon.svg"
          class="h-[15px] mr-3"
        />
        Sign in with Google
      </button>
      <!--end::Google link--->
    </div>
    <!--end::Col-->

    <!--begin::Col-->
    <div class="w-1/2">
      <!--begin::Google link--->
      <button
        pButton
        [outlined]="true"
        severity="secondary"
        class="flex items-center !py-3 !px-4"
      >
        <img
          alt="Logo"
          src="./assets/media/svg/brand-logos/apple-black.svg"
          class="h-[15px] mr-3"
        />
        Sign in with Apple
      </button>
      <!--end::Google link--->
    </div>
    <!--end::Col-->
  </div>
  <!--end::Login options-->

  <!--begin::Separator-->
  <div class="my-14 text-center">
    <span class="w-[125px] font-semibold text-sm text-muted"
      >Or with email</span
    >
  </div>
  <!--end::Separator-->

  <!-- begin::Alert error-->
  @if (hasError) {
  <div class="lg:mb-15">
    <div class="text-danger font-bold">
      The registration details are incorrect
    </div>
  </div>
  }
  <!-- end::Alert error-->

  <!--begin::Form group-->
  <div class="flex flex-col mb-7">
    <label class="form-label font-bold text-dark fs-6">Fullname</label>
    <input
      pInputText
      class="form-control !bg-transparent"
      type="text"
      name="fullname"
      formControlName="fullname"
      placeholder="Fullname"
      autocomplete="off"
      [ngClass]="{
        'is-invalid': registrationForm.controls['fullname'].invalid,
        'is-valid': registrationForm.controls['fullname'].valid
      }"
    />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Fullname is required',
        control: registrationForm.controls['fullname']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Fullname should have at least 3 symbols',
        control: registrationForm.controls['fullname']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Fullname should have maximum 100 symbols',
        control: registrationForm.controls['fullname']
      }"
    ></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="flex flex-col mb-7">
    <label class="form-label font-bold text-dark fs-6">Email</label>
    <input
      pInputText
      class="form-control !bg-transparent"
      type="email"
      placeholder="Email"
      name="email"
      formControlName="email"
      autocomplete="off"
      [ngClass]="{
        'is-invalid': registrationForm.controls['email'].invalid,
        'is-valid': registrationForm.controls['email'].valid
      }"
    />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: registrationForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: registrationForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Email should have at least 3 symbols',
        control: registrationForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: registrationForm.controls['email']
      }"
    ></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="flex flex-col mb-7">
    <label class="form-label font-bold text-dark fs-6">Password</label>
    <input
      pInputText
      class="form-control !bg-transparent"
      type="password"
      placeholder="Password"
      name="password"
      formControlName="password"
      autocomplete="off"
      [ngClass]="{
        'is-invalid': registrationForm.controls['password'].invalid,
        'is-valid': registrationForm.controls['password'].valid
      }"
    />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Password is required',
        control: registrationForm.controls['password']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Password should have at least 3 symbols',
        control: registrationForm.controls['password']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Password should have maximum 100 symbols',
        control: registrationForm.controls['password']
      }"
    ></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="flex flex-col mb-7">
    <label class="form-label font-bold text-dark fs-6">Confirm Password</label>
    <input
      pInputText
      class="form-control !bg-transparent"
      type="password"
      placeholder="Confirm password"
      name="cPassword"
      autocomplete="off"
      formControlName="cPassword"
      [ngClass]="{
        'is-invalid': registrationForm.controls['cPassword'].invalid,
        'is-valid': registrationForm.controls['cPassword'].valid
      }"
    />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Confirm Password is required',
        control: registrationForm.controls['cPassword']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Confirm Password should have at least 3 symbols',
        control: registrationForm.controls['cPassword']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Confirm Password should have maximum 100 symbols',
        control: registrationForm.controls['cPassword']
      }"
    ></ng-container>
    @if ( registrationForm.controls['cPassword'].errors &&
    registrationForm.controls['cPassword'].errors['ConfirmPassword'] ) {
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        'Password' and 'Confirm Password' didn't match.
      </div>
    </div>
    }
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="flex flex-col mb-7">
    <label class="flex items-center">
      <input
        type="checkbox"
        formControlName="agree"
        name="agree"
        class="form-check-input"
      />
      <span class="text-gray-700 ml-1">
        I Accept the<a
          target="_blank"
          class="ml-1 link-primary"
          >Terms</a
        >.
      </span>
    </label>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="mb-7 w-full">
    <button
      type="submit"
      pButton
      [size]="'large'"
      [disabled]="
        registrationForm.invalid || !registrationForm.controls['agree'].value
      "
      class="w-full"
    >
      @if ((isLoading$ | async) === false) {
      <span class="indicator-label">Submit</span>
      } @if (isLoading$ | async) {
      <span class="indicator-progress" [style.display]="'block'">
        Please wait...
        <span class="spinner-border spinner-border-sm align-middle ml-2"></span>
      </span>
      }
    </button>
  </div>
  <!--end::Form group-->

  <!--begin::Sign up-->
  <div class="text-gray-500 text-center fw-semibold fs-6">
    Already have an Account?

    <a routerLink="/auth/login" class="link-primary fw-semibold"> Sign in </a>
  </div>
  <!--end::Sign up-->
</form>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  @if (control.hasError(validation) && (control.dirty || control.touched)) {
  <div class="fv-plugins-message-container">
    <div class="fv-help-block">
      <span role="alert">
        {{ message }}
      </span>
    </div>
  </div>
  }
</ng-template>
